export const SHARE_LINK_FETCH_KEY = 'share.fetchShareLink';
export const LOCALSTORAGE_KEY = 'comscore:reduxState';
